import { render } from "./VOCPage.vue?vue&type=template&id=22c906da&scoped=true"
import script from "./VOCPage.vue?vue&type=script&lang=js"
export * from "./VOCPage.vue?vue&type=script&lang=js"

import "./VOCPage.vue?vue&type=style&index=0&id=22c906da&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22c906da"]])

export default __exports__